<script setup>
import { computed } from 'vue';
import { trans } from '@elements/translation';

const props = defineProps({
  modelValue: { type: String, required: true },
  error: { type: String, default: null },
  validationRules: { type: Object, required: true },
});

const emit = defineEmits([ 'update:modelValue' ]);

const name = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});
</script>

<template>
  <div class="content-form__field form-field">
    <label
      class="form-field__label"
      for="name"
    >{{ trans('addresses.details.form.field.name.label') }}{{ trans('global.required') }}</label>
    <div class="form-field__input field-input input-text">
      <input
        id="name"
        v-model="name"
        type="text"
        :minlength="validationRules.min_length"
        :maxlength="validationRules.max_length"
        name="name"
        :class="{ error: error !== null }"
        :placeholder=" trans('addresses.details.form.field.name.placeholder')"
        @focusout="$emit('focusout')"
      >
    </div>
    <span v-if="error" class="form-field__error">
      {{ error }}
    </span>
    <span class="form-field__helper">{{ trans('addresses.details.form.field.name.helper') }}</span>
  </div>
</template>
